import type { ReactNode } from 'react';
import { SyncConfigurationModal } from '../sync-configuration-modal/SyncConfigurationModal';
import { useSyncConfigurationMerchantModal } from './SyncConfigurationMerchantModal.hook';
import type { SyncConfigurationMerchantModalProps } from './SyncConfigurationMerchantModal.model';
import styles from './SyncConfigurationMerchantModal.module.scss';
export function SyncConfigurationMerchantModal({
  isOpen,
  isLoading: isLoadingSubmission,
  onSync,
  onCancel,
  merchantId,
}: SyncConfigurationMerchantModalProps): ReactNode {
  const { isLoading: isLoadingData, ...dashboardRowData } = useSyncConfigurationMerchantModal({ isOpen, merchantId });

  return (
    <SyncConfigurationModal
      scope="merchant"
      isOpen={isOpen}
      isLoading={isLoadingData}
      isLoadingSubmission={isLoadingSubmission}
      onSync={onSync}
      onCancel={onCancel}
      devicesClassName={styles.merchantDevices}
      dashboardRowData={dashboardRowData}
    />
  );
}
